function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React, { useState } from 'react';
import styled from 'styled-components';
import * as IconSet from "../../../../icons/index.js";
import Button from "../../../basic/Button/Button.js";
import Icon from "../../../basic/Icon/Icon.js";
import Tooltip from "../../../basic/Tooltip/Tooltip.js";
import { getAdjustedSize, getHintIconMargin, getHintIconSize, getItemIconSize, getItemPadding } from "../helpers.js";
var StyledDynamicItem = styled.li.withConfig({
  componentId: "CL__sc-1huwd9-0"
})(["align-items:center;border:solid 1px transparent;border-radius:var(--border-radius-x-small);color:var(--text-color-dim);cursor:grab;display:flex;gap:calc(var(--spacing-1) / 2);padding:", ";position:relative;:hover{background-color:var(--main-bkg-color);border-color:", ";}:active{background-color:", ";cursor:grabbing;z-index:1;}:focus-visible{outline:1px solid;outline-color:", ";}"], _ref => {
  var {
    size
  } = _ref;
  return getItemPadding(size);
}, _ref2 => {
  var {
    error
  } = _ref2;
  return error ? 'var(--error-color)' : 'var(--highlight-color)';
}, _ref3 => {
  var {
    error
  } = _ref3;
  return error ? 'var(--banner-critical-bkg-color)' : 'var(--main-bkg-color)';
}, _ref4 => {
  var {
    error
  } = _ref4;
  return error ? 'var(--error-color)' : 'var(--highlight-color)';
});
var StyledLabel = styled.span.withConfig({
  componentId: "CL__sc-1huwd9-1"
})(["flex-grow:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
var StyledButtonsWrapper = styled.div.withConfig({
  componentId: "CL__sc-1huwd9-2"
})(["display:flex;gap:var(--spacing-1);padding-left:var(--spacing-1);"]);
var StyledHintIcon = styled(Icon).withConfig({
  componentId: "CL__sc-1huwd9-3"
})(["margin:", ";"], _ref5 => {
  var {
    listSize
  } = _ref5;
  return getHintIconMargin(listSize);
});
var DynamicItem = _ref6 => {
  var {
    canDelete,
    canDuplicate,
    canEdit,
    item,
    onDelete,
    onDuplicate,
    onEdit,
    size,
    subject
  } = _ref6;
  var hasButtons = canEdit;
  var [isMouseOver, setIsMouseOver] = useState(false);
  var {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({
    id: item.id
  });
  var style = {
    transform: CSS.Transform.toString(transform),
    transition
  };
  return /*#__PURE__*/React.createElement(StyledDynamicItem, _extends({
    error: item.error,
    id: item.id.toString(),
    onMouseEnter: () => setIsMouseOver(true),
    onMouseLeave: () => setIsMouseOver(false),
    ref: setNodeRef,
    size: size,
    style: style
  }, attributes, listeners), item.icon && /*#__PURE__*/React.createElement(Icon, {
    component: isMouseOver ? IconSet.DotsVerticalDouble : item.icon,
    size: getItemIconSize(size)
  }), /*#__PURE__*/React.createElement(StyledLabel, {
    title: item.label
  }, item.label), (hasButtons || item.error) && /*#__PURE__*/React.createElement(StyledButtonsWrapper, null, !isMouseOver && !item.error && /*#__PURE__*/React.createElement(StyledHintIcon, {
    color: "var(--border-color)",
    component: IconSet.DotsHorizontalLarge,
    listSize: size,
    size: getHintIconSize(size)
  }), isMouseOver && /*#__PURE__*/React.createElement(React.Fragment, null, canDuplicate && /*#__PURE__*/React.createElement(Button, {
    "aria-label": "Duplicate ".concat(subject),
    icon: IconSet.Copy,
    size: getAdjustedSize(size),
    title: "Duplicate ".concat(subject),
    onClick: onDuplicate,
    variant: "text"
  }), canEdit && /*#__PURE__*/React.createElement(Button, {
    "aria-label": "Edit ".concat(subject),
    icon: IconSet.Pencil,
    size: getAdjustedSize(size),
    title: "Edit ".concat(subject),
    onClick: onEdit,
    variant: "text"
  }), canDelete && /*#__PURE__*/React.createElement(Button, {
    "aria-label": "Remove ".concat(subject),
    icon: IconSet.Trash,
    size: getAdjustedSize(size),
    title: "Remove ".concat(subject),
    onClick: onDelete,
    variant: "text"
  })), item.error && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledHintIcon, {
    color: "var(--error-color)",
    component: IconSet.WarningTriangleFilled,
    "data-for": "".concat(item.id, "-tooltip}"),
    "data-tip": true,
    listSize: size,
    size: getHintIconSize(size)
  }), /*#__PURE__*/React.createElement(Tooltip, {
    id: "".concat(item.id, "-tooltip}"),
    size: getAdjustedSize(size)
  }, "There\u2019s an issue with this ", subject))));
};
export default DynamicItem;